export default {
    devices_bulk_unpairing_title: "Unpair Paired Device",
    devices_bulk_unpairing_serial: "Serial",
    devices_bulk_unpairing_unpair: "Unpair",
    devices_bulk_unpairing_the_device_is_already_added: "The device is already added",
    devices_bulk_unpairing_devices_mush_have_other_linked_devices: "Devices must have other paired devices",
    devices_bulk_unpairing_device_not_found: "Device not found",
    devices_bulk_unpairing_vidfleet_esn: "VidFleet ESN",
    devices_bulk_unpairing_label: "Label",
    devices_bulk_unpairing_linked_to: "Paired to",

    devices_bulk_unpairing_the_device_has_been_unpaired: "The device has been unpaired",
    devices_bulk_unpairing_device_have_been_unpaired: "Devices have been unpaired",
    devices_bulk_unpairing_unpairing_the_gps: "Unpairing the gps",
    devices_bulk_unpairing_single_device: "Are you sure you want to unpair these devices?",
    devices_bulk_unpairing_transaction_message: "The request to unpair the devices has been sent successfully, please check the transactions list to see the status of the request.",
}


